import React from 'react';
import { Card } from 'react-bootstrap';

import { AccountSnapshotTable } from '@components/Dashboard/AccountSnapshot/AccountSnapshotTable';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page500 } from '@containers/ErrorPages';
import { dashboardApi } from '@reducers/dashboard/dashboard';

export const AccountSnapshot = () => {
  const { data, isLoading, isError } =
    dashboardApi.useGetAccountSnapshotQuery();
  return (
    <Card>
      <Card.Header className="text-center bg-didxl text-white">
        Account snapshot
      </Card.Header>
      <Card.Body>
        <Card.Text as="div" className="normalFontSize">
          {isLoading ? <DefaultSpinnerCenter /> : null}
          {isError ? <Page500 /> : null}
          {!isLoading && !isError ? <AccountSnapshotTable data={data} /> : null}
        </Card.Text>
      </Card.Body>
    </Card>
  );
};
